(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keast-brand-parts-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root = document) => root.querySelectorAll('[data-brand-parts]').forEach((hub) => {
    if (hub.dataset.initialized) return;
    hub.dataset.initialized = 'true';
    const contactDialog = hub.querySelector('[data-parts-contact-dialog]');
    if (contactDialog && typeof contactDialog.showModal === 'function') {
      let contactTrigger;
      hub.querySelectorAll('[data-parts-contact]').forEach((link) => {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', contactDialog.id);
        link.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          contactTrigger = link;
          contactDialog.showModal();
        });
        link.addEventListener('keydown', (event) => {
          if (event.key === ' ') { event.preventDefault(); link.click(); }
        });
      });
      contactDialog.querySelector('[data-parts-contact-close]').addEventListener('click', () => contactDialog.close());
      contactDialog.addEventListener('click', (event) => {
        if (event.target !== contactDialog) return;
        const bounds = contactDialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) contactDialog.close();
      });
      contactDialog.addEventListener('close', () => contactTrigger?.focus({ preventScroll: true }));
    }
    const form = hub.querySelector('[data-brand-parts-form]');
    const input = form.elements.q;
    const results = hub.querySelector('[data-parts-results]');
    const status = hub.querySelector('[data-parts-status]');
    const error = hub.querySelector('[data-parts-error]');
    const clear = hub.querySelector('[data-parts-clear]');
    const books = hub.querySelector('[data-parts-books]');
    let controller;
    let currentQuery = '';
    const initialParams = new URLSearchParams(location.search);
    const preview = initialParams.get('preview_theme_id');
    const addressKey = () => {
      const params = new URLSearchParams(location.search);
      const query = params.get('parts_q') || '';
      return JSON.stringify([location.pathname, query, Number(params.get(query ? 'parts_page' : 'page')) || 1]);
    };
    let knownAddress = addressKey();
    if (books && matchMedia('(max-width: 749px)').matches) books.open = false;
    hub.querySelector('[data-books-jump]')?.addEventListener('click', () => { if (books) books.open = true; });
    const searchUrl = (query, pageNumber = 1) => {
      const url = new URL(form.action, location.origin);
      for (const [key, value] of new FormData(form)) url.searchParams.set(key, value);
      url.searchParams.set('q', KeastSearch.build(query, 'parts', hub.dataset.brand));
      if (pageNumber > 1) url.searchParams.set('page', pageNumber);
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url;
    };
    const browseUrl = (pageNumber = 1) => {
      const url = new URL(hub.dataset.hubUrl, location.origin);
      if (pageNumber > 1) url.searchParams.set('page', pageNumber);
      if (preview) url.searchParams.set('preview_theme_id', preview);
      // The alternate template is only used while testing an unpublished theme.
      if (initialParams.has('view')) url.searchParams.set('view', initialParams.get('view'));
      return url;
    };
    async function load(query, pageNumber = 1, push = true, focus = true) {
      controller?.abort();
      controller = new AbortController();
      const active = controller;
      const timeout = setTimeout(() => active.abort(), 15000);
      const request = query ? searchUrl(query, pageNumber) : browseUrl(pageNumber);
      const fallback = new URL(request);
      request.searchParams.set('section_id', query ? 'keast-brand-parts-results' : hub.dataset.hubSection);
      results.hidden = false;
      results.setAttribute('aria-busy', 'true');
      error.hidden = true;
      status.textContent = hub.dataset.loading;
      try {
        const response = await fetch(request, { signal: active.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Parts request failed');
        let doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        let fragment = doc.querySelector('[data-parts-fragment]');
        // Shopify's scoped query can miss a literal part number that its native
        // filtered search finds. Try that form once before showing no matches.
        if (query && fragment?.dataset.partsEmpty === 'true') {
          const nativeRequest = new URL(request);
          nativeRequest.searchParams.set('q', query);
          const nativeResponse = await fetch(nativeRequest, { signal: active.signal, credentials: 'same-origin' });
          if (nativeResponse.ok) {
            const nativeDoc = new DOMParser().parseFromString(await nativeResponse.text(), 'text/html');
            const nativeFragment = nativeDoc.querySelector('[data-parts-fragment]');
            const nativeRows = [...(nativeFragment?.querySelectorAll('[data-part-vendor]') || [])];
            const nativeEmpty = nativeFragment?.dataset.partsEmpty === 'true' && nativeRows.length === 0;
            const nativeScoped = nativeFragment?.dataset.partsValid === 'true' && nativeFragment.dataset.partsBrand === hub.dataset.brand;
            if ((nativeEmpty || nativeScoped) && nativeRows.every((row) => (!hub.dataset.brand || row.dataset.partVendor === hub.dataset.brand) && KeastSearch.isParts(row.dataset.partType))) {
              doc = nativeDoc;
              fragment = nativeFragment;
            }
          }
        }
        const verifiedEmpty = fragment?.dataset.partsEmpty === 'true' && fragment.querySelectorAll('[data-part-vendor]').length === 0;
        if (!fragment || (!verifiedEmpty && (fragment.dataset.partsValid !== 'true' || fragment.dataset.partsBrand !== hub.dataset.brand))) throw new Error('Parts scope not verified');
        if ([...fragment.querySelectorAll('[data-part-vendor]')].some((row) => (hub.dataset.brand && row.dataset.partVendor !== hub.dataset.brand) || !KeastSearch.isParts(row.dataset.partType))) throw new Error('Unexpected part');
        if (active !== controller) return;
        if (query) {
          const list = fragment.querySelector('.keast-parts__list');
          const exact = query.trim().toLocaleLowerCase();
          const rows = [...(list?.children || [])];
          const matches = rows.filter((row) => row.querySelector('.keast-parts__sku')?.textContent.trim().toLocaleLowerCase() === exact);
          if (matches.length) list.prepend(...matches);
        }
        results.replaceChildren(fragment);
        currentQuery = query;
        input.value = query;
        clear.hidden = !query;
        if (push) {
          const address = browseUrl(query ? 1 : pageNumber);
          if (query) { address.searchParams.set('parts_q', query); if (pageNumber > 1) address.searchParams.set('parts_page', pageNumber); }
          history.pushState({}, '', address);
          knownAddress = addressKey();
        }
        status.textContent = results.querySelector('[data-results-heading]')?.textContent || hub.dataset.loaded;
        if (focus) results.querySelector('[data-results-heading]')?.focus({ preventScroll: false });
      } catch (exception) {
        if (active !== controller) return;
        results.hidden = true;
        error.hidden = false;
        hub.querySelector('[data-parts-fallback]').href = fallback.href;
        status.textContent = '';
      } finally {
        clearTimeout(timeout);
        if (active === controller) results.setAttribute('aria-busy', 'false');
      }
    }
    form.addEventListener('submit', (event) => { event.preventDefault(); load(KeastSearch.normalize(KeastSearch.decode(input.value).terms)); });
    clear.addEventListener('click', (event) => { if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return; event.preventDefault(); load(''); });
    results.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-part-page]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const pageNumber = Number(new URL(link.href).searchParams.get('page')) || 1;
      load(currentQuery, pageNumber);
    });
    const restore = (force = false) => {
      const nextAddress = addressKey();
      if (!force && nextAddress === knownAddress) return;
      knownAddress = nextAddress;
      const params = new URLSearchParams(location.search);
      const query = params.get('parts_q') || '';
      load(query, Number(params.get(query ? 'parts_page' : 'page')) || 1, false, false);
    };
    window.addEventListener('popstate', () => restore());
    if (initialParams.has('parts_q')) restore(true);
  });
  const start = () => {
    if (window.KeastSearch) initialize();
    else document.addEventListener('keast:search-ready', () => initialize(), { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  function initKeastCollectionTables(scope) {
    scope.querySelectorAll('[data-keast-collection-tables] table').forEach((table) => {
      if (table.dataset.keastScrollReady) return;
      table.dataset.keastScrollReady = 'true';
      const root = table.closest('[data-keast-collection-tables]');
      let scroller = table.parentElement;
      if (scroller === root || scroller.children.length !== 1 || scroller.tagName !== 'DIV') {
        scroller = document.createElement('div');
        table.before(scroller);
        scroller.append(table);
      }
      scroller.classList.add('keast-table-scroll');
      scroller.setAttribute('role', 'region');
      scroller.setAttribute('aria-label', root.dataset.tableLabel);
      table.style.minWidth = `${Math.min(960, (table.rows[0]?.cells.length || 2) * 170)}px`;
      const controls = document.createElement('div');
      controls.className = 'keast-table-controls';
      controls.hidden = true;
      const hint = document.createElement('span');
      hint.textContent = root.dataset.tableHint;
      const buttons = document.createElement('div');
      buttons.className = 'keast-table-buttons';
      const makeButton = (direction, label) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', label);
        button.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="${direction < 0 ? 'M14 6l-6 6 6 6' : 'M10 6l6 6-6 6'}"/></svg>`;
        button.addEventListener('click', () => scroller.scrollBy({ left: direction * scroller.clientWidth * .75, behavior: 'auto' }));
        buttons.append(button);
        return button;
      };
      const previous = makeButton(-1, root.dataset.tablePrevious);
      const next = makeButton(1, root.dataset.tableNext);
      controls.append(hint, buttons);
      scroller.before(controls);
      const update = () => {
        const max = scroller.scrollWidth - scroller.clientWidth;
        controls.hidden = max <= 2;
        scroller.tabIndex = max > 2 ? 0 : -1;
        previous.disabled = scroller.scrollLeft <= 2;
        next.disabled = scroller.scrollLeft >= max - 2;
      };
      scroller.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(scroller);
      update();
    });
  }
  initKeastCollectionTables(document);
  document.addEventListener('shopify:section:load', (event) => initKeastCollectionTables(event.target));

  } catch(e) { console.error(e); }
})();
})();
